import React, { useRef, ReactInstance, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ReactToPrint from '../../ReactToPrint'
import { connect } from 'react-redux'
import SeaWayBill from '../../SeaWayBill'
import VehicleCard from '../../VehicleCard'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction, setUIBackwardsAction } from '../../../actions'
import { checkinReservation } from '../../../actions/reservation'
import { UI } from '../../../constants/ui'
import check from '../../../assets/check-mark.svg'
import { AppState } from '../../../reducers'
import './confirmInformation.less'
import { isVehicleBoardingCardNeedReducer } from '../../../reducers/terminal'
import { isDangerousGoodsShowSelector } from '../../../reducers/terminal'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

class EmptyComponent extends React.Component {
  render() {
    return null
  }
}

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  checkinRes: checkinReservation,
}

type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  checkinSuccess: state.reservation.checkinSuccess,
  terminal: state.terminal.terminal,
  isVehicleBoardingCardNeed: isVehicleBoardingCardNeedReducer(state),
  isDangerousGoodsShow: isDangerousGoodsShowSelector(state),
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

interface CustomMobileProps {
  confirmData: boolean
  isWarningMessage: boolean
  clickConfirmationData: () => void
  clickConfirmationGoods: () => void
  confirmGoods: boolean
  onCheckIn: () => any
  isActivePrintButton: boolean
}

type ConfirmInformationMobileProps = CustomMobileProps & Pick<Props, 'setUIBackwards' | 'isDangerousGoodsShow'>


const ConfirmInformationMobile: React.FC<ConfirmInformationMobileProps> = ({ setUIBackwards, confirmData, isWarningMessage, clickConfirmationData, isDangerousGoodsShow, clickConfirmationGoods, confirmGoods, onCheckIn, isActivePrintButton }) => {
  const { t } = useTranslation()
  return (
    <div className="confirm-information-mobile">
      <div className="confirm-information-mobile-wrapper">
        <div className="confirm-information-title" dangerouslySetInnerHTML={{ __html: t('confirmInformationConfirm') + ':' }}></div>
        <div className="confirm-info">
          <div className="confirm-text">
            <div className="check-button">
              <button
                className={`confirm-button ${confirmData ? 'selected-check-button' : ''} ${!confirmData && isWarningMessage ? 'warning-check-button' : ''
                  }`}
                onClick={clickConfirmationData}
              >
                {(confirmData || !isWarningMessage) && <img className="check" src={check} alt="check" />}
              </button>
            </div>

            <div className="confirm-data" onClick={clickConfirmationData}>
              {t('confirmInformationIsCorrect')}
            </div>
          </div>
          {isDangerousGoodsShow && (
            <div className="confirm-goods" onClick={clickConfirmationGoods}>
              <div className="check-button">
                <button
                  className={`confirm-button ${confirmGoods ? 'selected-check-button' : ''} ${!confirmGoods && isWarningMessage ? 'warning-check-button' : ''
                    }`}
                  onClick={clickConfirmationGoods}
                >
                  {(confirmGoods || !isWarningMessage) && <img className="check" src={check} alt="check" />}
                </button>
              </div>
              {t('confirmInformationNoDangerous')}
            </div>
          )}
          {!isDangerousGoodsShow && <div className="confirm-goods">&nbsp;</div>}
        </div>
        <div className="confirm-information-button">
          {isWarningMessage && <div className="warning-message">{t('readAndMarkCheckboxes')}</div>}
          <div className="one-button-row">
            <button className="main-button-mobile" onClick={onCheckIn} disabled={!isActivePrintButton}>
              {t('confirm')}
            </button>
          </div>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount back={() => setUIBackwards(UI.SUMMARY)} />
      </div>
    </div>
  )
}

interface CustomDesktopProps {
  confirmData: boolean
  isWarningMessage: boolean
  clickConfirmationData: () => void
  clickConfirmationGoods: () => void
  confirmGoods: boolean
  onCheckIn: () => any
  isActivePrintButton: boolean
  onClickFakePrintButton: () => void
  buttonSWBRef: React.MutableRefObject<any>
  onCurrentSWB: () => any
  onAfterSWBPrint: () => void
  seaWayBillRef: React.MutableRefObject<any>
  buttonVehicleCardRef: React.MutableRefObject<HTMLButtonElement | null>
  onCurrentVehicleCard: () => any
  onAfterVehicleCardPrint: () => void
  vehicleCardRef: React.MutableRefObject<any>
}

type ConfirmInformationDesktopProps = CustomDesktopProps & Pick<Props, 'setUIBackwards' | 'terminal' | 'reservation' | 'isDangerousGoodsShow'>

const ConfirmInformationDesktop: React.FC<ConfirmInformationDesktopProps> = ({ setUIBackwards, confirmData, isWarningMessage, clickConfirmationData, isDangerousGoodsShow, clickConfirmationGoods, confirmGoods, onCheckIn, isActivePrintButton, onClickFakePrintButton, buttonSWBRef, onCurrentSWB, onAfterSWBPrint, seaWayBillRef, reservation, terminal, buttonVehicleCardRef, onCurrentVehicleCard, onAfterVehicleCardPrint, vehicleCardRef }) => {
  const { t } = useTranslation()
  if (!reservation) {
    return null
  }
  return (
    <>
      <Header showPageCount back={() => setUIBackwards(UI.SUMMARY)} />
      <div className="confirm-information">
        <div className="confirm-information-title" dangerouslySetInnerHTML={{ __html: t('confirmInformationConfirm') + ':' }}></div>
        <div className="confirm-info">
          <div className="confirm-text">
            <div className="check-button">
              <button
                className={`confirm-button ${confirmData ? 'selected-check-button' : ''} ${!confirmData && isWarningMessage ? 'warning-check-button' : ''
                  }`}
                onClick={clickConfirmationData}
              >
                {(confirmData || !isWarningMessage) && <img className="check" src={check} alt="check" />}
              </button>
            </div>

            <div className="confirm-data" onClick={clickConfirmationData}>
              {t('confirmInformationIsCorrect')}
            </div>
          </div>
          {isDangerousGoodsShow && (
            <div className="confirm-goods" onClick={clickConfirmationGoods}>
              <div className="check-button">
                <button
                  className={`confirm-button ${confirmGoods ? 'selected-check-button' : ''} ${!confirmGoods && isWarningMessage ? 'warning-check-button' : ''
                    }`}
                  onClick={clickConfirmationGoods}
                >
                  {(confirmGoods || !isWarningMessage) && <img className="check" src={check} alt="check" />}
                </button>
              </div>
              {t('confirmInformationNoDangerous')}
            </div>
          )}
          {!isDangerousGoodsShow && <div className="confirm-goods">&nbsp;</div>}
        </div>
        <div className="confirm-information-button">
          {isWarningMessage && <div className="warning-message">{t('readAndMarkCheckboxes')}</div>}
          <div className="one-button-row">
            <button className="main-button ok" onClick={onCheckIn} disabled={!isActivePrintButton}>
              {t('confirm')}
            </button>
          </div>

          <div className="sea-way-template">
            <button
              className="fake-button-for-print"
              onClick={onClickFakePrintButton}
              disabled={!confirmData || (isDangerousGoodsShow && !confirmGoods)}
            ></button>

            <ReactToPrint
              trigger={() => <button ref={buttonSWBRef} className="hidden-button" />}
              content={onCurrentSWB}
              copyStyles
              onAfterPrint={onAfterSWBPrint}
            />
            <div ref={seaWayBillRef}>
              <SeaWayBill reservation={reservation} terminal={terminal} />
            </div>
          </div>
          <div className="vehicle-card-template">
            <ReactToPrint
              trigger={() => <button ref={buttonVehicleCardRef} className="hidden-button" />}
              content={onCurrentVehicleCard}
              copyStyles
              onAfterPrint={onAfterVehicleCardPrint}
            />
            <div ref={vehicleCardRef}>
              <VehicleCard reservation={reservation} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}


const ConfirmInformation: React.FC<Props> = ({
  setUIForward,
  setUIBackwards,
  reservation,
  checkinRes,
  checkinSuccess,
  terminal,
  isVehicleBoardingCardNeed,
  isDangerousGoodsShow,
}: Props) => {
  const [confirmData, setConfirmationData] = useState(false)
  const [confirmGoods, setConfirmationGoods] = useState(false)
  const ele: ReactInstance = new EmptyComponent({})
  const seaWayBillRef = useRef<any>(null)
  const buttonSWBRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentSWB = () => (seaWayBillRef.current ? seaWayBillRef.current : ele)
  const [isActivePrintButton, toggleActivityOfPrintButton] = useState(true)
  const vehicleCardRef = useRef<any>(null)
  const buttonVehicleCardRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentVehicleCard = () => (vehicleCardRef.current ? vehicleCardRef.current : ele)
  const [isWarningMessage, setWarningMessage] = useState(false)

  const mode = getMode()

  const areAllChecked = () => {
    if (confirmData && (isDangerousGoodsShow ? confirmGoods : true)) {
      return true
    } else {
      setWarningMessage(true)
      return false
    }
  }
  const onCheckIn = () => areAllChecked() && reservation && checkinRes(reservation.resId)

  const clickConfirmationData = () => {
    setConfirmationData(!confirmData)
    setWarningMessage(false)
  }
  const clickConfirmationGoods = () => {
    setConfirmationGoods(!confirmGoods)
    setWarningMessage(false)
  }

  const onAfterSWBPrint = () => {
    setUIForward(UI.CHECKIN_DONE)
  }
  const onAfterVehicleCardPrint = () => {
    setUIForward(UI.PRINT_SWB)
  }

  const onClickFakePrintButton = () => {
    toggleActivityOfPrintButton(false)
    if (isVehicleBoardingCardNeed) {
      onAfterVehicleCardPrint()
    } else {
      onAfterSWBPrint()
    }
  }
  useEffect(() => {
    if (checkinSuccess && mode === MODE.KIOSK) {
      toggleActivityOfPrintButton(false)
      if (isVehicleBoardingCardNeed) {
        buttonVehicleCardRef.current && buttonVehicleCardRef.current.click()
      } else {
        buttonSWBRef.current && buttonSWBRef.current.click()
      }
    }
    if (checkinSuccess && mode !== MODE.KIOSK) {
      setUIForward(UI.DOWNLOAD_SWB)
    }
  }, [checkinSuccess, isVehicleBoardingCardNeed])

  if (mode === MODE.MOBILE) {
    const mobileProps = { setUIBackwards, confirmData, isWarningMessage, clickConfirmationData, isDangerousGoodsShow, clickConfirmationGoods, confirmGoods, onCheckIn, isActivePrintButton }
    return <ConfirmInformationMobile {...mobileProps} />
  } else {
    const desktopProps = { setUIBackwards, confirmData, isWarningMessage, clickConfirmationData, isDangerousGoodsShow, clickConfirmationGoods, confirmGoods, onCheckIn, isActivePrintButton, onClickFakePrintButton, buttonSWBRef, onCurrentSWB, onAfterSWBPrint, seaWayBillRef, reservation, terminal, buttonVehicleCardRef, onCurrentVehicleCard, onAfterVehicleCardPrint, vehicleCardRef }
    return <ConfirmInformationDesktop {...desktopProps} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmInformation)
